import { useState } from 'react';
import type { WorkspaceFile } from '../../types';
import { CodeBlock } from '../../components/CodeBlock';
import { RelativeTime } from '../../components/RelativeTime';

// Lo spazio di lavoro della sessione: i file che gli agenti hanno scritto, dal vivo.
export function FilesPanel({ files }: { files: WorkspaceFile[] }) {
  const [current, setCurrent] = useState<string | null>(null);
  if (files.length === 0) {
    return (
      <div className="t-caption faint" style={{ padding: 24, textAlign: 'center' }}>
        Nessun file: i Pops non hanno ancora scritto nello spazio di lavoro.
      </div>
    );
  }
  const shown = files.find((f) => f.path === current) ?? files[0];
  return (
    <div style={{ display: 'flex', gap: 16, padding: '16px 20px 32px', minWidth: 0 }}>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, width: 220, flex: 'none' }}>
        {files.map((f) => (
          <li key={f.path}>
            <button
              onClick={() => setCurrent(f.path)}
              className="t-mono-xs"
              style={{
                width: '100%',
                textAlign: 'left',
                border: 'none',
                borderRadius: 'var(--r-sm)',
                padding: '6px 8px',
                cursor: 'pointer',
                color: 'var(--text)',
                background: f.path === shown.path ? 'var(--bg-2)' : 'transparent',
                overflowWrap: 'anywhere',
              }}
            >
              {f.path}
            </button>
          </li>
        ))}
      </ul>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="t-caption faint" style={{ marginBottom: 6 }}>
          {shown.path} · {shown.bytes} byte · <RelativeTime at={shown.updatedAt} />
        </div>
        <CodeBlock code={shown.content ?? ''} />
      </div>
    </div>
  );
}
